var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.computedClass }, [
    _c(
      "input",
      _vm._g(
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.modelValue,
              expression: "modelValue",
            },
          ],
          staticClass: "jade-checkbox__input",
          attrs: {
            type: "checkbox",
            id: _vm.indentifier,
            name: _vm.name,
            disabled: _vm.disabled,
            indeterminate: _vm.indeterminate,
            "aria-invalid": _vm.error,
            "aria-disabled": _vm.disabled || _vm.readOnly,
            "aria-checked": _vm.isIndeterminate(_vm.modelValue)
              ? "mixed"
              : _vm.modelValue,
            defaultChecked: _vm.isIndeterminate(_vm.defaultChecked)
              ? false
              : _vm.defaultChecked,
          },
          domProps: {
            checked: Array.isArray(_vm.modelValue)
              ? _vm._i(_vm.modelValue, null) > -1
              : _vm.modelValue,
          },
          on: {
            change: function ($event) {
              var $$a = _vm.modelValue,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.modelValue = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.modelValue = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.modelValue = $$c
              }
            },
          },
        },
        _vm.$listeners
      )
    ),
    _c("label", { attrs: { for: _vm.indentifier } }, [
      _c(
        "div",
        { class: _vm.computedClassBox },
        [
          _vm.indeterminate
            ? _c("JadeIcon", { attrs: { use: "minus", size: "small" } })
            : _c("JadeIcon", { attrs: { use: "check", size: "small" } }),
        ],
        1
      ),
      _vm.label
        ? _c(
            "span",
            { staticClass: "jade-checkbox__label" },
            [
              _c(
                "JadeText",
                {
                  attrs: {
                    color: "current-color",
                    variant: "text-medium",
                    weight: "regular",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.label) + " ")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.supportText
        ? _c(
            "span",
            { staticClass: "jade-checkbox__support" },
            [
              _c(
                "JadeText",
                {
                  attrs: {
                    color: "current-color",
                    variant: "text-small",
                    weight: "regular",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.supportText) + " ")]
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }